import Toast from '../toastComponent';
import fetchRequest from "../fetchRequest";
import inputValidation from "../../../../helpers/inputValidation";
import { adobePageViewTracking, getPageNameId, logAlsClickthru } from "../../../../helpers/osTracking";
import Cookies from "js-cookie";

const testDriveDateIndex = 0;
const testDriveCommentsIndex = 2;
const phoneInputCommentsIndex = 0;
const osId = getPageNameId('os');
const twowks = 12096e5; // two weeks time in milliseconds, e for scientific notation


/*eslint-disable camelcase*/
class MultiActionForms {
    constructor(vin, OS_MODAL, emitter) {
        this.vin = vin;
        this.preferredContact = "phone or email";
        this.testDriveTime = "";
        this.today = new Date().toISOString().split('T')[0];
        this.twoWeeksOut = new Date(Date.now() + twowks).toISOString().split('T')[0];
        this.multiDate = document.getElementsByClassName("multi-date")[0];
        //querySelect
        this.phoneForm = OS_MODAL.querySelector('.phone-call-form__container');
        this.phoneInput = OS_MODAL.querySelector('.phone-number__container .phone-number__input');
        this.phoneError = OS_MODAL.querySelector('.phone-number__container .input-error');
        this.phoneComments = OS_MODAL.querySelector('.comments-container textarea');
        this.phoneTime = OS_MODAL.querySelector('.time-container input');
        this.phoneDate = OS_MODAL.querySelector('.date-container input');

        this.questionForm = OS_MODAL.querySelector('.question-form__container');
        this.questionContact = this.questionForm.querySelector('.contact-method__container');

        this.testDriveForm = OS_MODAL.querySelector('.test-drive-form__container');
        this.testDriveTimeChevron = this.testDriveForm.querySelector('.time-container__icon-wrapper');
        this.testDriveTimeInput = this.testDriveForm.querySelector('.time-container select');
        this.testDriveTimeError = this.testDriveForm.querySelector('.time-error');
        this.testDriveDateInput = this.testDriveForm.querySelector('.date-container input');
        this.testDriveDateError = this.testDriveForm.querySelector('.date-error');

        this.closeButton = OS_MODAL.querySelector('[name="close"]');
        //bind event handlers
        this._handlePhoneFormSubmit = this._handlePhoneFormSubmit.bind(this);
        this._handleQuestionSubmit = this._handleQuestionSubmit.bind(this);
        this._handleContactChange = this._handleContactChange.bind(this);
        this._handleTestDriveSubmit = this._handleTestDriveSubmit.bind(this);
        this._handleTimeClick = this._handleTimeClick.bind(this);
        this._handleTimeChange = this._handleTimeChange.bind(this);
        this._handleDateInput = this._handleDateInput.bind(this);
        //add event listener
        /*istanbul ignore next*/
        this.phoneInput.addEventListener("keyup", event => inputValidation.formatPhoneNumber(event, this.phoneInput));
        this.phoneInput.addEventListener("blur", () => this._validatePhoneInput());
        this.phoneForm.addEventListener("submit", event => this._handlePhoneFormSubmit(event), false);

        this.questionContact.addEventListener("change", event => this._handleContactChange(event));
        this.questionForm.addEventListener("submit", event => this._handleQuestionSubmit(event), false);

        this.testDriveForm.addEventListener("submit", event => this._handleTestDriveSubmit(event), false);
        this.testDriveTimeInput.addEventListener("change", event => this._handleTimeChange(event));
        this.testDriveTimeInput.addEventListener("click", this._handleTimeClick);

        // form validation actions
        this._setMinMaxDate();

        /*istanbul ignore next*/
        if ((window.browserName === "Safari" && window.deviceType === "desktop") ||
            (window.browserName && window.browserName.name && window.browserName.name === "IE ")) {
            this.testDriveDateInput.addEventListener("input", event => this._handleDateInput(event));
        }

        emitter.on("update-person-data", (personData) => {
            this.personData = personData;
            if (this.personData && this.personData.home_phone) {
                this._setPhoneInput(this.personData.home_phone);
            }
        });
    }

    init(fetchParams, personData, vehicleState) {
        this.personData = personData;
        this.vehicleState = vehicleState;
        this.fetchParams = fetchParams;

        if (this.personData && this.personData.home_phone) {
            this._setPhoneInput(this.personData.home_phone);
        }
    }

    _validatePhoneInput() {
        const valuePhone = this.phoneInput.value.replace(/\W/g, '');
        if (inputValidation.validateField('phone', valuePhone)) {
            this.personData.home_phone = valuePhone;
            this.phoneError.classList.add("hidden");
            this.phoneInput.classList.remove("error");
            fetchRequest.patchPerson(this.fetchParams, this.personData);
            this._setCookie();
        } else {
            this.personData.home_phone = "";
            this.phoneError.classList.remove("hidden");
            this.phoneInput.classList.add("error");
        }
    }

    _setCookie() {
        const expDays = 7;
        const cookieName = `ElectricLeadSent${this.vin}`;

        Cookies.set(cookieName, this.personData, { expires: expDays });
    }

    _setPhoneInput(phoneNumber) {
        this.phoneInput.value = "(" + phoneNumber.slice(0,3) + ") " + phoneNumber.slice(3,6) + "-" + phoneNumber.slice(6);
    }

    async _handlePhoneFormSubmit(event) {
        if (!this.personData.home_phone ) {
            this._validatePhoneInput();
            return;
        }

        logAlsClickthru(osId, getPageNameId('phoneCall', this.vehicleState.payments.selected));
        const commentsValue = event.target[phoneInputCommentsIndex].value;

        const requestBody = {
            first_name: this.personData.first_name,
            last_name: this.personData.last_name,
            phone: this.personData.home_phone,
            email: this.personData.email,
            comment: `Please call me at ${this.personData.home_phone}. ` + commentsValue
        };

        try {
            await fetchRequest.postToReserve(this.fetchParams, this.vin, requestBody);

            Toast.show('check-circle', 'Success!', 'The dealer will call you soon.');
            adobePageViewTracking('onlineShopper/connectPhone', 'connect-phone', 'onlineShopper/connectPhone/success');
            this.closeButton.click();
        } catch (error) {
            Toast.show('exclamation-circle', 'Oops, Sorry!', 'Unable to complete request, please try again later', 3000, true);
        }
    }

    _handleContactChange(event) {
        this.preferredContact = event.target.value;
    }

    _handleTimeClick() {
        this.testDriveTimeChevron.classList.add("expanded");
    }

    _handleTimeChange(event) {
        this.testDriveTimeChevron.classList.remove("expanded");
        this.testDriveTime = `in the ${event.target.value}`;
    }

    _handleDateInput(event) {
        let rawValue = event.target.value.replace(/[\D]/g, '');

        const month = rawValue.slice(0,2);
        const day = rawValue.slice(2, 4);
        const year = rawValue.slice(4,8);

        this._validateDateInput(month, day, year);

        let formattedValue = month;
        if (day) {
            formattedValue += "/" + day ;
        }
        if (year) {
            formattedValue += "/" + year;
        }

        event.target.value = formattedValue;
    }

    _validateDateInput(month, day, year) {
        const parsedMonth = parseInt(month, 10);
        const parsedDay = parseInt(day, 10);
        const parsedYear = parseInt(year, 10);
        const fullDate = new Date(parsedYear, parsedMonth - 1, parsedDay).toISOString().split('T')[0];
        if ((fullDate < this.today) || (fullDate > this.twoWeeksOut)) {
            this._setDateError();
            this.testDriveDateError.innerHTML = "Please enter a date between " + this.today + " and " + this.twoWeeksOut;
        } else {
            this._clearDateError();
        }
    }

    _setMinMaxDate() {
        this.multiDate.setAttribute('min', this.today);
        this.multiDate.setAttribute('max', this.twoWeeksOut);
    }

    _setDateError() {
        this.testDriveDateInput.classList.add("error");
        this.testDriveDateError.classList.remove("hidden");
    }

    _clearDateError() {
        this.testDriveDateInput.classList.remove("error");
        this.testDriveDateError.classList.add("hidden");
    }

    async _handleQuestionSubmit(event) {
        logAlsClickthru(osId, getPageNameId('askQuestion', this.vehicleState.payments.selected));
        const questionCommentsValue = event.target[0].value;
        const requestBody = {
            first_name: this.personData.first_name,
            last_name: this.personData.last_name,
            phone: this.personData.home_phone,
            email: this.personData.email,
            comment: `I have a question about this vehicle. Please contact me by ${this.preferredContact}. ` + questionCommentsValue
        };

        try {
            await fetchRequest.postToReserve(this.fetchParams, this.vin, requestBody);

            Toast.show('check-circle', 'Success!', 'The seller will be in touch to answer your questions.');
            adobePageViewTracking('onlineShopper/connectQuestion', 'connect-question', 'onlineShopper/connectQuestion/success');
            this.closeButton.click();
        } catch (error) {
            Toast.show('exclamation-circle', 'Oops, Sorry!', 'Unable to complete request, please try again later', 3000, true);
        }
    }

    async _handleTestDriveSubmit(event) {
        logAlsClickthru(osId, getPageNameId('testDrive', this.vehicleState.payments.selected));
        let invalid = false;
        let testDriveDateValue = event.target[testDriveDateIndex].value;
        const testDriveCommentsValue = "I would like to schedule a test drive. " + event.target[testDriveCommentsIndex].value;

        if (testDriveDateValue === "") {
            this._setDateError();
        }

        if (this.testDriveTime === "") {
            this.testDriveTimeInput.classList.add("error");
            this.testDriveTimeError.classList.remove("hidden");
        } else {
            this.testDriveTimeInput.classList.remove("error");
            this.testDriveTimeError.classList.add("hidden");
        }
        if (this.testDriveDateInput.classList.contains("error") || this.testDriveTimeInput.classList.contains("error")) {
            invalid = true;
        }

        if (invalid) {
            return;
        } else {
            /*istanbul ignore next*/
            if ((window.browserName === "Safari" && window.deviceType === "desktop") ||
                (window.browserName && window.browserName.name && window.browserName.name === "IE ")) {
                const dateArray = testDriveDateValue.split('/');
                testDriveDateValue = `${dateArray[2]}-${dateArray[0]}-${dateArray[1]}`;
            }
            const requestBody = {
                "date": testDriveDateValue,
                "time": this.testDriveTime,
                "home": false,
                "comments": testDriveCommentsValue
            };

            try {
                await fetchRequest.postToPickUp(this.fetchParams, requestBody);

                Toast.show('check-circle', 'Success!', 'The dealer will be in touch to confirm your test drive.');
                adobePageViewTracking('onlineShopper/connectTestDrive', 'connect-testdrive', 'onlineShopper/connectTestDrive/success');
                this.closeButton.click();
            } catch (error) {
                Toast.show('exclamation-circle', 'Oops, Sorry!', 'Unable to complete request, please try again later', 3000, true);
            }
        }
    }
}

export default MultiActionForms;